import React from 'react';

const CustomerSection = ({ 
  taskForm,
  setTaskForm,
  customers,
  newCustomerMode,
  setNewCustomerMode,
  newCustomerData,
  setNewCustomerData,
  validationErrors = {}
}) => {
  const handleCustomerChange = (value) => {
    if (value === 'new-customer') {
      setNewCustomerMode(true);
      setTaskForm(prev => ({ ...prev, customerId: '' }));
    } else {
      setNewCustomerMode(false);
      setTaskForm(prev => ({ ...prev, customerId: value }));
    }
  };

  const handleNewCustomerDataChange = (field, value) => {
    setNewCustomerData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="form-group customer-section">
        <label htmlFor="customer">Customer <span style={{ color: '#64748b', fontWeight: 500 }}>(optional)</span></label>
        <select
          id="customer"
          className="form-control"
          value={newCustomerMode ? 'new-customer' : taskForm.customerId}
          onChange={(e) => handleCustomerChange(e.target.value)}
        >
          <option value="">Select Customer</option>
          <option value="new-customer">+ Add New Customer</option>
          {customers.map(customer => (
            <option key={customer.id} value={customer.id}>
              {customer.name}
            </option>
          ))}
        </select>
      {!newCustomerMode && !!taskForm.customerId && (
        <div className="assignment-preview" style={{ marginTop: 8 }}>
          {(() => {
            const selected = customers.find(c => c.id === parseInt(taskForm.customerId));
            if (!selected) return null;
            return (
              <div>
                <div style={{ fontWeight: 700 }}>{selected.name}</div>
                <div style={{ fontSize: 12, color: '#475569' }}>
                  {selected.email || 'No email'}
                  {selected.phone ? ` · ${selected.phone}` : ''}
                </div>
              </div>
            );
          })()}
        </div>
      )}
      {newCustomerMode && (
        <div className="new-customer-card">
          <h4>New Customer Details</h4>
          <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>
            Provide at least one contact: email or phone.
          </div>

          <div className="combined-inputs">
            <div className="mini-field">
              <input
                type="text"
                className={`form-control${validationErrors.newCustomerName ? ' error' : ''}`}
                value={newCustomerData.name}
                onChange={(e) => handleNewCustomerDataChange('name', e.target.value)}
                placeholder="Customer name *"
                required
              />
              {validationErrors.newCustomerName && (
                <div className="field-error-message">{validationErrors.newCustomerName}</div>
              )}
            </div>
            <div className="mini-field">
              <input
                type="email"
                className={`form-control${validationErrors.newCustomerEmail ? ' error' : ''}`}
                value={newCustomerData.email}
                onChange={(e) => handleNewCustomerDataChange('email', e.target.value)}
                placeholder="Customer email"
              />
              {validationErrors.newCustomerEmail && (
                <div className="field-error-message">{validationErrors.newCustomerEmail}</div>
              )}
            </div>
            <div className="mini-field">
              <input
                type="tel"
                className="form-control"
                value={newCustomerData.phone}
                onChange={(e) => handleNewCustomerDataChange('phone', e.target.value)}
                placeholder="Customer phone"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerSection; 